export default {
  category: 'book',
  name: 'White Fragility',
  author: 'Robin DiAngelo',
  date: '8/5/20',
  path: '/notes/white-fragility',
  photo: 'https://twos.s3.amazonaws.com/parkerklein/parker-klein-white-fragility-robin-diAngelo.jpg',
  tags: ['Social Science', 'Relationships'],
  time: 1,
  rating: 7.8,
  review: '',
  link: 'https://www.amazon.com/White-Fragility-People-About-Racism/dp/0807047414',
  mediumLink: '',
  patreonLink: '',
  // podcastLink: 'https://anchor.fm/parkerklein/episodes/',
  // podcastEmbed: 'https://anchor.fm/parkerklein/embed/episodes/',
  // youtubeLink: 'https://youtu.be/',
twosLink: '',
  // youtubeEmbed: 'https://www.youtube.com/embed/',
  releaseDate: ''
};
